import { render, staticRenderFns } from "./Q1.vue?vue&type=template&id=584f9483&scoped=true&"
import script from "./Q1.vue?vue&type=script&lang=js&"
export * from "./Q1.vue?vue&type=script&lang=js&"
import style0 from "./Q1.vue?vue&type=style&index=0&id=584f9483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f9483",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VContainer,VTextField})
